// keep in sync from app rules.ts
export const RULES = {
  MAX_GARDENS: {
    FREE: 1,
    // SUB is unlimited
  },
  MAX_PLANS: {
    FREE: 1,
    // SUB is unlimited
  },
  MIN_GARDEN_WIDTH: 1,
  MIN_GARDEN_LENGTH: 1,
  MAX_GARDEN_WIDTH: {
    FREE: 20,
    SUB: 100,
  },
  MAX_GARDEN_LENGTH: {
    FREE: 20,
    SUB: 100,
  },
  MAX_GARDEN_HISTORY_MONTHS: {
    FREE: 6,
    // SUB can view all history
  },
  MAX_GARDEN_FUTURE_YEARS: 2,
  MAX_PLANTS_PER_SQUARE: {
    FREE: 1,
    SUB: 3,
  },
  MAX_NOTE_IMAGES: 6,
};
